import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlSystemsService } from './control-systems.service'; // Ajusta la ruta
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, EMPTY, first, map, Observable, ReplaySubject, tap, throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {


  private initialized = false;
  private readonly controlSystemNameSubject = new BehaviorSubject<string>('');
  controlSystemName$ = this.controlSystemNameSubject.asObservable();

  private readonly tokensReadySubject = new ReplaySubject<boolean>(1);
  public tokensReady$ = this.tokensReadySubject.asObservable();

  private readonly hasAccessSubject = new BehaviorSubject<boolean | null>(null);
  hasAccess$ = this.hasAccessSubject.asObservable();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly controlSystemsService: ControlSystemsService,
    private readonly titleService: Title,
    private readonly router: Router,
  ) { }

  public init(url?: string): void {
    if (this.initialized) return;
    this.initialized = true;
    this.route.queryParams.pipe(first()).subscribe(params => {
      let token = params['token'] || this.route.snapshot.queryParams['token'];
      let controlsystemId = params['controlsystemId'] || this.route.snapshot.queryParams['controlsystemId'];
      let guid = params['guid'] || this.route.snapshot.queryParams['guid'];
      let appId = params['appsId'] || this.route.snapshot.queryParams['appsId'];
      if (url) {
        const urlParams = new URLSearchParams(url.includes('?') ? url.split('?')[1] : url);
        token = urlParams.get('token') ?? token;
        controlsystemId = urlParams.get('controlsystemId') ?? controlsystemId;
        guid = urlParams.get('guid') ?? guid;
        appId = urlParams.get('appsId') ?? appId;
      }
      const storedToken = sessionStorage.getItem('idtoken');
      if (!storedToken && !token) {
          this.hasAccessSubject.next(false);
          this.tokensReadySubject.next(true);
          return;
      }

      if (storedToken) {
        this.tokensReadySubject.next(true);
      }
      // Process token
      if (token) {
        sessionStorage.setItem('idtoken', token);
        try {
          const payloadBase64 = token.split('.')[1];
          const payload = JSON.parse(atob(payloadBase64));
          sessionStorage.setItem('username', payload.preferred_username || '');
        } catch (e) {
          console.error('Error parsing JWT:', e);
        }
      }
      this.hasAccessSubject.next(true);
      if (controlsystemId) {
        sessionStorage.setItem('controlsystemId', controlsystemId);
        console.log('External ID recibido:', controlsystemId);
      }
      if (guid) {
        sessionStorage.setItem('guid', guid);
        console.log('External guid recibido:', guid);
      }
      if (appId) {
        sessionStorage.setItem('appId', appId);
        console.log('External appId recibido:', appId);
      }
      this.controlSystemsService.getAppSessions(guid).pipe(
        map(response => {

          console.log(response);
          sessionStorage.setItem('account', response.session);
          const account = JSON.parse(decodeURIComponent(response.session));
          sessionStorage.setItem('username', account.username);
          if (token != null) {
            this.postControlSystemsToken$().subscribe({
              next: () => {
                console.log('[AppInit] postControlSystemsToken$ completed - tokens ready');
                this.tokensReadySubject.next(true);
              },
              error: (err) => {
                console.error('[AppInit] postControlSystemsToken$ failed', err);
                this.tokensReadySubject.next(false);
              }
            });
          } else {
            this.tokensReadySubject.next(true);
          }

        }),
        catchError((err: HttpErrorResponse) => {
          console.error('Error Control Systems Apps:', err);
          return EMPTY;
        })
      ).subscribe();
    });
  }

  public setTokenStatus(status: boolean): void {
    this.tokensReadySubject.next(status);
  }

  postControlSystemsToken$(): Observable<{ access_token: string, resource: string, slot: string }> {
    const token = sessionStorage.getItem('idtoken')!;
    const controlsystemId = sessionStorage.getItem('controlsystemId')!;
    const appId = sessionStorage.getItem('appId')!;

    return this.controlSystemsService.postControlSystemsToken(controlsystemId, appId, token).pipe(
      tap(res => {
        console.log('Control Systems Token response:', res);
        sessionStorage.setItem('access_token', res.access_token);
        sessionStorage.setItem('resource', res.resource);
        sessionStorage.setItem('slot', res.slot);
        sessionStorage.setItem('controlsystem', res.controlsystem);
        sessionStorage.setItem('controlsystemname', res.controlsystemname);
        sessionStorage.setItem('roles', res.roles);
        sessionStorage.setItem('customer', res.customer);
        sessionStorage.setItem('customername', res.customername);
        sessionStorage.setItem('factory', res.factory);
        sessionStorage.setItem('factoryname', res.factoryname);
        this.titleService.setTitle(`CEH ${res.customername} - ${res.factoryname} `);
        this.updateControlSystemName(res.customername, res.factoryname, res.controlsystemname);
      }),
      catchError(err => {
        console.error('Error Control Systems Token:', err);
        return throwError(() => err);
      })
    );
  }

  updateControlSystemName(customername: string = '', factoryname: string = '', controlsystemname: string = ''): void {
    const name = `${customername} - ${factoryname} - ${controlsystemname}`;
    this.controlSystemNameSubject.next(name);
  }

}
